// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"WD-z","shipmentMessage":"XD-z","shipmentNumber":"YD-z","trackingProgressContainer":"ZD-z"};